import {
  useMostAccessedCatalogsSource,
  UseMostAccessedCatalogsSourceParams,
} from './most-accessed-catalogs-source';

export const useMostAccessedCatalogsByTagsSource = (
  params: UseMostAccessedCatalogsSourceParams,
  options?: { enabled?: boolean }
) => useMostAccessedCatalogsSource('tags', params, options);
